export const Panel = {};

export const CustomPanel = {
	panelBorderColor: 'var(--epods--color-border)',
	panelPadding: 'var(--epods--panel-padding)',
	panelHeaderIconMarginRight: 'var(--epods--panel-header-padding-margin-icon)',
	panelHeaderHeight: 'var(--epods--panel-header-height)',
	panelHeaderTextSize: 'var(--epods--panel-header_text-size)',
	subPanelHeaderTextSize: 'var(--epods--subpanel-header_text-size)',
	panelHeaderTextHeight: 'var(--epods--panel-header_text-height)',
	panelContentTextSize: 'var(--epods--panel-content_text-size)',
	panelContentTextHeight: 'var(--epods--panel-content_text-height)',
	panelTextColor: 'var(--epods--color-text-ds-dark)',
	subPanelTextColor: 'var(--epods--color-text-button-tertiary)',
	panelHeaderTextWeight: 'var(--epods--panel-header_text-weight)',
	panelContentTextWeight: 'var(--epods--panel-content_text-weight)',
};
